import { render, staticRenderFns } from "./HealthInformation.vue?vue&type=template&id=51a04e39&scoped=true"
import script from "./HealthInformation.vue?vue&type=script&lang=js"
export * from "./HealthInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a04e39",
  null
  
)

export default component.exports